export const listEmoji = [
	'✊',
	'✋',
	'👆',
	'👇',
	'👈',
	'👉',
	'👊',
	'👌',
	'👍',
	'👎',
	'👏',
	'🤘',
	'🤝',
	'🤞',
	'💪',
	'🖐',
	'🙌',
	'☝',
	'👋',
	'🤚',
	'✋',
	'🖖',
	'🤟',
	'🤘',
	'🤙',
	'🖕',
	'🤛',
	'🤜',
	'🤲',
	' 🙏 ',
	'✍',
	'💅',
	'🤳',
	'😍',
	'🤗',
	'😎',
	'💥',
	'💕',
	'💙'
];
